export class AuthConstants {
    public static readonly userIdentityHash = `user_identity_hash`;
}
